import React from 'react';
export function HowItWorks() {
  const phases = [{
    num: '1',
    title: 'Fase de Reset',
    days: 'Día 1-3',
    desc: 'Eliminamos los 3 inflamadores silenciosos de tu cocina para vaciar el exceso de líquido.'
  }, {
    num: '2',
    title: 'Fase de Equilibrio',
    days: 'Día 4-10',
    desc: 'Introducimos los superalimentos que apagan el cortisol y activan la quema de grasa.'
  }, {
    num: '3',
    title: 'Fase de Sostenibilidad',
    days: 'Día 11-14',
    desc: 'Blindamos tu metabolismo para que los resultados se mantengan a largo plazo.'
  }];
  return <section className="bg-sage-dark py-16 md:py-24 px-6 text-white" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 text-white" data-id="element-104">
          Cómo funciona en 14 días
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-105">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-sage-light/30 z-0" data-id="element-106"></div>

          {phases.map((phase, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-107">
              <div className="w-24 h-24 rounded-full bg-cream text-sage-dark flex items-center justify-center text-3xl font-bold font-playfair mb-6 shadow-lg border-4 border-sage-dark" data-id="element-108">
                {phase.num}
              </div>
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 w-full h-full" data-id="element-109">
                <span className="inline-block px-3 py-1 bg-gold text-charcoal-dark text-sm font-bold rounded-full mb-4" data-id="element-110">
                  {phase.days}
                </span>
                <h3 className="text-2xl font-bold mb-4 font-playfair" data-id="element-111">
                  {phase.title}
                </h3>
                <p className="text-sage-light text-lg leading-relaxed" data-id="element-112">
                  {phase.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}